module.exports = __webpack_public_path__ + "assets/GoldPi2x.1c60a41ebd25761447add373b0994b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldPi2x.png
// module id = 819
// module chunks = 0